module.exports = __webpack_public_path__ + "bin/561cc6a323231861b6ba5c02be8e17e2.woff2";